import { useEffect, useState } from 'react';
import { Modal, Avatar, Typography, Row, Col, Upload, Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Controller, useForm } from 'react-hook-form';
import { Input } from "antd";
import { Notification } from "../../components/notification/notification";
import { RcFile } from 'antd/lib/upload';
import { useDispatch } from 'react-redux';
import { uploadUserProfileRequest, uploadUserrProfileLoader } from '../../screens/users/states/action';
import { useSelector } from 'react-redux';
import { Buffer } from "buffer";
import { GetRequest, PutRequest, replaceWithCurrentApiVersion } from '../../utils/api';
import CustomLoader from '../../components/loader';


const { Title, Text } = Typography;

const ProfilePopup = ({ visible, onCancel, user }: any) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const rootState = useSelector((state: any) => state?.userReducer);

  let {
    userProfileUpload: { data: userProfileUpload },
  } = rootState

  const dispatch = useDispatch();

  const submitForm = async (values: any) => {
   
    try {


      PutRequest(replaceWithCurrentApiVersion(`users/platform/{version}/api/my-info-details/${user.ecode}`), { ...values, myInfoFile: userProfileUpload?.data.fileId }).then(() => {
        Notification("success", "Record updated successfully");
        setEditButton(true);
      })
    } catch (error) {
      setEditButton(true);
      Notification("error", "Something went wrong");
    }
  };
  const [editButton, setEditButton] = useState(true);
  const [controllerEdit, setControllerEdit] = useState(true);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>();
  const [fileList, setFileList] = useState<any[]>([]);
  const getBase64 = (img: RcFile, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result as string));
    reader.readAsDataURL(img);
  };

  const EditButton = () => {
    setControllerEdit(false)
    setEditButton(false)
  }
  const getImageData = async () => {
    if (user.profileImagePath) {
    

      GetRequest(`users/platform/document/download/${user.profileImagePath}`, 'arraybuffer').then((response) => {
        const base64Image = Buffer.from(response, 'binary').toString('base64');
        setImageUrl(`data:image/jpeg;base64,${base64Image}`);
      });
    }
  }
  useEffect(() => {
    getImageData();
  }, [user]);

  const handleChange = async (info: any) => {
    // setLoading(true);
    dispatch(uploadUserrProfileLoader([]));
    dispatch(uploadUserProfileRequest({ selectedFile: fileList[0] }));
    getBase64(fileList[0] as RcFile, (url: any) => {
      setImageUrl(url);
    });
    // }
  };

  const beforeUpload = (file: RcFile) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      Notification("success", 'You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      Notification("error", 'Image must smaller than 2MB!');
    }
    setFileList([file]);
    // handleChange([]);
    return isJpgOrPng && isLt2M;
  };


  return (
    <Modal
      open={visible}
      title="My Info"
      onCancel={onCancel}
      footer={null}
    >

      <form onSubmit={handleSubmit(submitForm)}>
        <Row gutter={[16, 16]}>
          <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
            <Upload
              name="avatar"
              listType="picture"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              // onChange={handleChange}
              disabled={controllerEdit}
              customRequest={({ file, onSuccess, onError }) => {
                // You can perform your custom upload logic here
                // In this example, we are using the handleFileUpload function defined above
                handleChange([])
              }}
            >
              {/* {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton} */}
              {loading ?
                <Avatar size={100} src={imageUrl || user.profileImage} icon={<CustomLoader size="sm"></CustomLoader>} /> : <Avatar size={100} src={imageUrl} icon={<UserOutlined rev={undefined} />} />
              }


            </Upload>
          </Col>
          <Col span={12}>
            <Title level={5}>User ID:</Title>
            <Text>{user.userId}</Text>
          </Col>
          <Col span={12}>
            <Title level={5}>Name:</Title>
            <Text>{user.name}</Text>
          </Col>
          <Col span={12}>
            <Title level={5}>Mobile No:</Title>
            <Controller
              name="primaryContactNumber"
              control={control}
              rules={{
                required: 'Please enter valid mobile number',
                minLength: 10,
                maxLength: 10,
                pattern: {
                  value: /^[789]\d{9}$/,
                  message: ''
                }
              }}
              defaultValue={user.primaryContactNumber}
              render={({ field }) => <Input type="number" disabled={controllerEdit} maxLength={50}
                {...field} />}
            />
            {errors.primaryContactNumber && <p className="ant-form-item-explain-error">Please enter valid mobile number</p>}

          </Col>
          <Col span={12}>
            <Title level={5}>Email:</Title>
            <Controller
              name="email"
              control={control}
              rules={{
                required: 'Please enter valid Email',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: 'Please enter valid Email',
                },
              }}
              defaultValue={user?.email}
              render={({ field }) => <Input type="text" disabled={controllerEdit} maxLength={50}
                {...field} />}
            />
            {errors.email && <p className="ant-form-item-explain-error">Please enter valid Email</p>}

          </Col>

          <Col span={12}>
            <Title level={5}>Ecode:</Title>
            <Text>{user.ecode}</Text>
          </Col>
          <Col span={12}>
            <Title level={5}>Role:</Title>
            <Text>{user.roleCode}</Text>
          </Col>
          <Col span={12}>
            <Title level={5}>Hierarchy User:</Title>
            <Text>{user.notInHierarchy ? 'True' : 'False'}</Text>
          </Col>

        </Row>
        <div className='adminbutton mt-3 text-right'>
          {editButton ? <Button htmlType="button" type="primary" onClick={(ev) => { ev.preventDefault(); EditButton(); }}>Edit</Button>
            : <Button type='primary' htmlType='submit'>Submit</Button>}
        </div>
      </form>

    </Modal>
  );
};

export default ProfilePopup;


